import {searchGreenWay} from '@/api/green-way/green-way.api';
import {getAllRegionProvinces} from '@/api/province/province.api';
import {
  selectionModeEnum,
  filtersTypeEnum,
  advancedSearchComponentEnum,
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';
import {router, store} from '@/pages/_root/main';

export const GREEN_WAYS_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincia',
  },
  {
    field: 'route',
    label: 'Recorrido',
  },
];

const defaultPropertiesDropDown = {
  options: [],
  optionLabel: 'name',
  optionValue: 'name',
};
function greenWayToText(
  {
    name,
    description,
    route,
    routeSteps,
    province,
    poi,
    leisure,
    access,
  }) {
  const sep = '\n      ';
  const routeString = sep + routeSteps.join(sep);
  const res = `
    Nombre: ${name}
    Descripción: ${description}
    Recorrido: ${route}
    Paradas: ${routeString}
    Provincia: ${province}
    Lugares de interés: ${poi}
    Ocio: ${leisure}
    Acceso: ${access}
  `;
  return res;
}
function copyGreenWayText(data, copy) {
  const text = greenWayToText(data);
  copy(text);
}
function printGreenWay(data) {
  const text = greenWayToText(data);
  console.log('print: ' + text);
  router.push({name: 'queryGreenWaysPdfId', params: {id: data.id}});
}
async function goGreenWay({coordinates}) {
  const zoom = 10;
  console.log('goGreenWay: ', {coordinates, zoom});
  await store.dispatch('map/setCenter', {center: coordinates}, {root: true});
  await store.dispatch('map/setZoom', {zoom}, {root: true});
}

export default class QueryGreenWaysTableConfig {
  constructor({copyClipboard = null, printQuery = null}) {
    return {
      title: '',
      api: searchGreenWay,
      schema: [
        {
          field: 'name',
          label: 'Nombre',
        },
        {
          field: 'province',
          label: 'Provincia',
        },
      ],
      actions: {
        header: [
          {
            label: 'Imprimir',
            icon: 'print',
            extended: false,
            command: () => printQuery(),
          },
        ],
        item: [
          {
            label: 'Centrar en el mapa',
            icon: 'arrow_circle_right',
            extended: false,
            disabled: (data) => !data.coordinates || !data.coordinates.length,
            command: (e) => goGreenWay(e.data),
          },
          {
            label: 'Copiar texto completo',
            icon: 'book',
            extended: false,
            disabled: () => !copyClipboard,
            command: (e) => copyGreenWayText(e.data, copyClipboard),
          },
          {
            label: 'Imprimir',
            icon: 'print',
            extended: false,
            command: (e) => printGreenWay(e.data),
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.GLOBAL,
          fields: [
            {
              field: 'name',
              label: 'Nombre',
              type: formItemTypeEnum.INPUTTEXT,
              value: '',
              matchMode: matchModeEnum.CONTAINS,
              operator: operatorEnum.AND,
            },
          ],
        },
        {
          type: filtersTypeEnum.ADVANCED,
          component: advancedSearchComponentEnum.SIDEBAR,
          fields: [
            {
              field: 'name',
              label: 'Nombre',
              type: formItemTypeEnum.INPUTTEXT,
              value: '',
              matchMode: matchModeEnum.CONTAINS,
              operator: operatorEnum.AND,
            },
            {
              field: 'province',
              label: 'Provincia',
              type: formItemTypeEnum.DROPDOWN,
              value: null,
              matchMode: matchModeEnum.EQUALS,
              operator: operatorEnum.AND,
              properties: defaultPropertiesDropDown,
              events: {
                onMounted: async (updateModel) => {
                  const {provinces} = await getAllRegionProvinces();
                  updateModel((item) => {
                    item.properties.options = provinces;
                    return item;
                  });
                },
              },
            },
            {
              field: 'region',
              label: 'Comunidad Autónoma',
              type: formItemTypeEnum.DROPDOWN,
              value: null,
              matchMode: matchModeEnum.EQUALS,
              operator: operatorEnum.AND,
              properties: defaultPropertiesDropDown,
              events: {
                onMounted: async (updateModel) => {
                  const {regions} = await getAllRegionProvinces();
                  updateModel((item) => {
                    item.properties.options = regions;
                    return item;
                  });
                },
              },
            },
          ],
        },
      ],
      views: [
        {
          type: 'table',
          selectionMode: selectionModeEnum.UNSET,
          shownActions: 3,
        },
        {
          type: 'list',
        },
      ],
    };
  }
}
